import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { useState } from "react";
import { sendContactMessage } from "./services/authService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function HelpCenter() {
  const navigate = useNavigate();
const [userType, setUserType] = useState("");
   const [formData, setFormData] = useState({
      name: "",
      email: "",
      mobile_no: "",
      you_are: "",
      organization_name: "",
      message: "",
    });
    const [loading, setLoading] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // ✅ NAME → allow only letters & space
    if (name === "name") {
      const onlyText = value.replace(/[^A-Za-z ]/g, "");
      setFormData({ ...formData, name: onlyText });
      return;
    }
  
    // ✅ CONTACT → only numbers + max 10 digits
    if (name === "mobile_no") {
      const onlyNumbers = value.replace(/[^0-9]/g, "").slice(0, 10);
      setFormData({ ...formData, mobile_no: onlyNumbers });
      return;
    }
  
    // default
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
        setLoading(true);
  
        const res = await sendContactMessage(formData);
  
        if (res.success === "1") {
          toast.success(res.message); // ✅ SUCCESS TOAST
  
          setFormData({
            name: "",
            email: "",
            mobile_no: "",
            you_are: "",
            organization_name: "",
            message: "",
          });
        } else {
          toast.error(res.message); // fallback
        }
      } catch (error) {
        console.error(error);
  
        toast.error(error?.message || "Failed to send message. Try again."); // ❌ ERROR TOAST
      } finally {
        setLoading(false);
      }
    };

  const faqs = [
    {
      q: "How do I book a ride?",
      a: "Enter your pickup and drop-off locations, select your preferred cab type (Micro, Mini, Sedan, SUV, Bike, or Auto), and confirm. You’ll see the estimated fare instantly and confirm the ride. Scheduled rides are available too."
    },
    {
      q: "What payment methods are accepted?",
      a: "Pay via UPI, credit/debit cards, net banking, or Rolo Wallet in the app. Cash payments are available for all rides. All fares are shown upfront."
    },
    {
      q: "How can I become a Rolo driver?",
      a: "Visit the Become a Driver section on our website or download the app to register."
    },
    {
      q: "How do I contact support during a ride?",
      a: "You can use the SOS button, contact customer support instantly, or end the ride if needed. Your safety is our top priority."
    }
  ];

  return (
    <div className="support-page">

      <Navbar />

      {/* HERO */}
      <section className="support-hero">
        <h1>Welcome to<br/>Rolo Support!</h1>

        <p>
          We're here to help you every step of the way.<br/>
          Looking for assistance or need to reach our customer service team?<br/>
          Explore the support resources below to find quick solutions and the best way to get in touch<br/>
          for your specific need.
        </p>
      </section>


      {/* SUPPORT CATEGORY CARDS */}
      <section className="support-categories">

        <div className="category-card">
          <h3>Rides & Booking</h3>
          <p>Help with booking, cancellations, and ride issues.</p>
        </div>

        <div className="category-card">
          <h3>Payments & Refunds</h3>
          <p>Manage fares, refunds, and payment methods.</p>
        </div>

        <div className="category-card">
          <h3>Account & Profile</h3>
          <p>Fix app errors, updates, and performance issues.</p>
        </div>

        <div className="category-card">
          <h3>Safety & Security</h3>
          <p>Learn how we keep you safe before, during, and after rides.</p>
        </div>

        <div className="category-card">
          <h3>Drivers & Partners</h3>
          <p>Info for driver registration and earnings.</p>
        </div>

        <div className="category-card">
          <h3>App & Technical Help</h3>
          <p>Manage login, account settings, and documents.</p>
        </div>

      </section>


      {/* SUPPORT CARD */}
      <section className="support-card">

        <div className="card-title">
          – Have questions? We've got answers!
        </div>

        <div className="card-desc">
          Explore quick solutions to common queries about rides, payments,
          driver onboarding, and more.
        </div>

      </section>


      {/* FAQ LIST */}
      <section className="faq-section">

        {faqs.map((faq, index) => (
          <div key={index} className="faq-block">

            <div className="faq-question">
              – {faq.q}
            </div>

            <div className="faq-answer">
              {faq.a}
            </div>

          </div>
        ))}

        <div 
  className="faq-link"
  style={{ cursor: "pointer" }}
  onClick={() => navigate("/faq")}
>
  View all FAQs »
</div>

      </section>


      {/* ASSISTANCE BANNER */}
      <section className="assist-banner">
        <h2>
          Still Need Assistance?<br/>
          We are here to help
        </h2>
      </section>


      <p className="support-desc">
        Our support team is available to assist you with any questions,
        ride issues, or account concerns.
      </p>


      {/* CONTACT FORM */}
      <section className="contact-support">

        <p className="form-title">
          Fill the form and our team will get back to you at the earliest.
        </p>

        <form onSubmit={handleSubmit}>
                {/* NAME */}
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="form-label"
                    style={{ color: "#FC9344", fontSize: "12px" }}
                  >
                    *Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{
                      backgroundColor: "#69696966",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                    }}
                  />
                </div>

                {/* EMAIL + CONTACT SIDE BY SIDE */}
                <div className="row mb-3">
                  <div className="col-6">
                    <label
                      htmlFor="email"
                      className="form-label"
                      style={{ color: "#FC9344", fontSize: "12px" }}
                    >
                      *Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{
                        backgroundColor: "#69696966",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>

                  <div className="col-6">
                    <label
                      htmlFor="contact"
                      className="form-label"
                      style={{ color: "#FC9344", fontSize: "12px" }}
                    >
                      Contact Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="contact"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      style={{
                        backgroundColor: "#69696966",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label
                    className="form-label"
                    style={{ color: "#FC9344", fontSize: "12px" }}
                  >
                    *You are a
                  </label>

                  <select
                    className="form-control"
                    name="you_are"
                    value={formData.you_are}
                    onChange={(e) => {
                      handleChange(e);
                      setUserType(e.target.value);
                    }}
                    required
                    style={{
                      backgroundColor: "#69696966",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                    }}
                  >
                    <option value="">Select</option>
                    <option value="Driver">Driver</option>
                    <option value="Customer">Customer</option>
                    <option value="Organisation">Organisation</option>
                  </select>
                </div>

                {/* ORGANISATION FULL WIDTH */}
                {userType === "Organisation" && (
                  <div className="mb-3">
                    <label
                      htmlFor="org"
                      className="form-label"
                      style={{ color: "#FC9344", fontSize: "12px" }}
                    >
                      Organisation Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="org"
                      name="organization_name"
                      value={formData.organization_name}
                      onChange={handleChange}
                      required={userType === "Organisation"}
                      style={{
                        backgroundColor: "#69696966",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                )}
                {/* MESSAGE */}
                <div className="mb-3">
                  <label
                    htmlFor="message"
                    className="form-label"
                    style={{ color: "#FC9344", fontSize: "12px" }}
                  >
                    *Message
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="4"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    style={{
                      backgroundColor: "#69696966",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                    }}
                  ></textarea>
              
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#FFFFFF",
                      marginTop: "5px",
                      display: "block",
                    }}
                  >
                    By using this website, you consent to our use of cookies and
                    collection of personal data as outlined in our Privacy
                    Policy.
                  </span>
                </div>

                <button
                  type="submit"
                  className="btn"
                  style={{
                    width: "100%",
                    height: "50px",
                    borderRadius: "9px",
                    background:
                      "linear-gradient(90deg, #D25A00 0%, #FF7F1F 100%)",
                    border: "none",
                    color: "#fff",
                    fontWeight: "600",
                  }}
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>

      </section>


      <Footer />


<style>{`

.support-page{
background:#000;
color:white;
font-family:Inter, sans-serif;
overflow-x:hidden;

min-height:100vh;
display:flex;
flex-direction:column;
}
/* HERO */

.support-hero{
text-align:center;
padding:140px 20px 80px;
}

.support-hero h1{
font-size:70px;
font-weight:800;

background:linear-gradient(90deg,#FF7F1F,#C25300);
-webkit-background-clip:text;
-webkit-text-fill-color:transparent;

margin-bottom:20px;
}

.support-hero p{
color:#ddd;
font-size:16px;
line-height:1.6;
}

/* SUPPORT CARD */

.support-card{
width:90%;
margin:auto;
}

.card-title{
background:#e6d8cc;
color:#000;
padding:10px 15px;
font-weight:600;
}

.card-desc{
background:#000;
color:#ccc;
padding:10px 15px;
border-bottom:1px solid #444;
}

/* SUPPORT CATEGORY CARDS */

.support-categories{
width:85%;
max-width:1100px;
margin:0 auto 60px auto;

display:grid;
grid-template-columns:repeat(2,534px);
justify-content:center;
gap:40px;
}

/* CATEGORY CARD */

.category-card{
width:450px;
height:150px;

background:#F3CDB1;
border:1px solid #C25300;
border-radius:20px;

box-shadow:0px 5px 4.4px rgba(0,0,0,0.1);

display:flex;
flex-direction:column;
justify-content:center;

padding:25px 40px;

transition:0.3s;
cursor:pointer;
}

.category-card:hover{
transform:translateY(-5px);
}

/* TITLE */

.category-card h3{
color:#C25300;
margin-left:120px;
font-weight:700;
font-size:20px;
line-height:121%;
}

/* DESCRIPTION */

.category-card p{
color:#000000;
font-size:16px;
line-height:1.4;
margin-left:120px;
}

/* FAQ */

.faq-section{
width:90%;
margin:auto;
}

.faq-block{
margin-bottom:2px;
}

.faq-question{
background:#e6d8cc;
color:#000;
padding:10px 15px;
font-weight:600;
}

.faq-answer{
background:#000;
color:#ccc;
padding:10px 15px;
font-size:14px;
border-bottom:1px solid #333;
}

.faq-link{
color:#ff8c32;
padding:10px 0;
cursor:pointer;
}

/* ASSIST BANNER */

.assist-banner{
background:#FF7F1F;
text-align:center;
padding:70px 20px;
margin-top:80px;
}

.assist-banner h2{
font-size:40px;
font-weight:800;
color:#FBEFE6;
}

/* CONTACT */

.support-desc{
color:#ddd;
font-size:16px;
margin:20px 0 0 5%;
}

/* CONTACT FORM */

.contact-support{
width:80%;
margin:auto;
padding:80px 0;
flex:1;
}

.form-title{
margin-bottom:30px;
font-size:16px;
color:#ccc;
}

.support-form{
display:flex;
flex-direction:column;
gap:18px;
}

.form-label{
color:#FC9344;
font-size:12px;
margin-bottom:5px;
display:block;
}

.support-form input,
.support-form select,
.support-form textarea{
width:100%;
background:#2b2b2b;
border:none;
padding:14px;
color:white;
border-radius:6px;
font-size:14px;
}

.support-form textarea{
height:140px;
resize:none;
}

.row{
display:flex;

}

.field{
flex:1;
display:flex;
flex-direction:column;
}

.form-note{
font-size:11px;
color:#888;
line-height:1.5;
}

.form-note span{
color:#ff8c32;
}

.support-form button{
width:100%;
background:#ff8c32;
border:none;
padding:14px;
color:white;
border-radius:6px;
font-size:16px;
cursor:pointer;
transition:0.3s;
}

.support-form button:hover{
background:#e77722;
}

/* MOBILE */

@media(max-width:768px){

.contact-support{
width:90%;
}

.row{
flex-direction:column;
}

}

@media(max-width:900px){

.support-hero h1{
font-size:36px;
}

.contact-support{
width:90%;
}

.row{
flex-direction:column;
}

.support-categories{
grid-template-columns:1fr;
}

}

`}</style>

    </div>
  );
}

export default HelpCenter;